import {
    DATE_RANGE_OPTIONS,
    DATE_RANGE_PRESET_SETS,
    DATE_RANGE_DEFAULTS,
} from '../config/dateRangeConfig';

export function getDateRangeOptionsForReport(reportConfig = {}) {
    const presetSetKey = reportConfig.datePresetSet || 'default';
    const presetGroups = DATE_RANGE_PRESET_SETS[presetSetKey] || DATE_RANGE_PRESET_SETS.default;

    return presetGroups
        .map((group) => ({
            label: group.label,
            options: (group.options || [])
                .map((key) => DATE_RANGE_OPTIONS[key])
                .filter(Boolean),
        }))
        .filter((group) => group.options.length > 0);
}

export function getDefaultDateRangeForReport(reportConfig = {}) {
    if (reportConfig.defaultDateRange) {
        return reportConfig.defaultDateRange;
    }

    const presetSetKey = reportConfig.datePresetSet || 'default';
    return DATE_RANGE_DEFAULTS[presetSetKey] || DATE_RANGE_DEFAULTS.default;
}

export function getDateRangeLabel(value, reportConfig = {}) {
    const optionGroups = getDateRangeOptionsForReport(reportConfig);

    for (const group of optionGroups) {
        const match = group.options.find((opt) => opt.value === value);
        if (match) return match.label;
    }

    return value || '';
}

export function isDateRangeAllowedForReport(value, reportConfig = {}) {
    const optionGroups = getDateRangeOptionsForReport(reportConfig);

    return optionGroups.some((group) =>
        group.options.some((opt) => opt.value === value)
    );
}